module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/204-guernsey-7fad5bd66050eb561c8280f289916e8f.svg";